function getWishlistCount(list) {
  if (!list) return 0;
  if (Array.isArray(list.listcontents)) return list.listcontents.length;
  if (Array.isArray(list.items)) return list.items.length;
  if (Array.isArray(list.products)) return list.products.length;
  return Number(list.cnt || list.count || list.item_count || 0) || 0;
}

function updateWishlistHeaderCounter(listOrCount) {
  var count = typeof listOrCount === 'number' ? listOrCount : getWishlistCount(listOrCount);
  document.querySelectorAll('.swym-wishlist-header-counter').forEach(function(counter) {
    counter.textContent = String(count);
    counter.setAttribute('aria-label', count + ' wishlist items');
    counter.dataset.count = String(count);
  });
}

function storeWishlist(list) {
  window.apps = window.apps || {};
  window.apps.wishlist = {
    listId: list && list.lid,
    list: list
  };

  updateWishlistHeaderCounter(list);
  if (typeof publish === 'function') publish('wishlist-loaded', list);
}

function refreshWishlistHeaderCounter() {
  if (window.apps && window.apps.wishlist && window.apps.wishlist.list) {
    updateWishlistHeaderCounter(window.apps.wishlist.list);
    return;
  }

  updateWishlistHeaderCounter(0);
}

function ensureWishlistList(swat, callback, errorCallback) {
  window.apps = window.apps || {};

  if (window.apps.wishlist && window.apps.wishlist.listId) {
    callback(window.apps.wishlist);
    return;
  }

  if (!swat || typeof swat.fetchLists !== 'function') {
    if (typeof errorCallback === 'function') errorCallback(new Error('Swym is not ready'));
    return;
  }

  swat.fetchLists({
    callbackFn: function(lists) {
      if (lists && lists.length) {
        storeWishlist(lists[0]);
        callback(window.apps.wishlist);
        return;
      }

      swat.createList({ lname: 'wishlist' }, function(newList) {
        storeWishlist(newList);
        callback(window.apps.wishlist);
      }, function(error) {
        if (typeof errorCallback === 'function') errorCallback(error);
      });
    },
    errorFn: function(error) {
      if (typeof errorCallback === 'function') errorCallback(error);
    }
  });
}

window.apps = window.apps || {};
window.apps.ensureWishlistList = ensureWishlistList;

// Keep the badge readable even before Swym is allowed by consent/loading.
refreshWishlistHeaderCounter();
document.addEventListener('DOMContentLoaded', refreshWishlistHeaderCounter);
window.addEventListener('pageshow', refreshWishlistHeaderCounter);
setTimeout(refreshWishlistHeaderCounter, 500);
setTimeout(refreshWishlistHeaderCounter, 2000);

//Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {
  // Define success callback
  let onSuccess = function(lists) {
    // If lists array is empty
    if (lists.length == 0) {
      // Define the list config
      let listConfig = {
        "lname": "wishlist", // unique list name.
      };

      // Define success callback
      let onSuccess = function(newList) {
        // Executed when a new list is successfully created
        storeWishlist(newList);
      }

      // Define error callback
      let onError = function(error) {
        // Error is an xhrObject
        console.error("Error while creating a List", error);
        refreshWishlistHeaderCounter();
      }

      // Create a new list with the above callbacks and config
      swat.createList(listConfig, onSuccess, onError);
    } else {
      storeWishlist(lists[0]);
    }
  }

  // Define error callback
  let onError = function(error) {
    // Error is an xhrObject
    console.error("Error while fetching all Lists", error);
    refreshWishlistHeaderCounter();
  }

  // Call `fetchLists` function
  swat.fetchLists({
    callbackFn: onSuccess,
    errorFn: onError
  });
}

window.onSwymLoadCallback = onSwymLoadCallback;
window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(window.onSwymLoadCallback);

if (window._swat) {
  console.info("Swym scripts tags are installed on your store");
} else {
  console.error("Swym scripts tags aren`t installed on your store");
}

// Leving local wishlist fallback: keeps hearts functional when Swym is blocked or not loaded.
(function() {
  var storageKey = 'levingWishlist';
  var memoryWishlist = [];

  function getStorage() {
    try {
      if (window.localStorage) return window.localStorage;
    } catch (error) {}
    return null;
  }

  function readWishlist() {
    var storage = getStorage();
    if (!storage) return memoryWishlist;

    try {
      var parsed = JSON.parse(storage.getItem(storageKey) || '[]');
      memoryWishlist = Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      memoryWishlist = [];
    }

    return memoryWishlist;
  }

  function writeWishlist(items) {
    memoryWishlist = items;

    var storage = getStorage();
    if (storage) {
      try {
        storage.setItem(storageKey, JSON.stringify(items));
      } catch (error) {}
    }

    if (typeof updateWishlistHeaderCounter === 'function') updateWishlistHeaderCounter(items.length);
  }

  function getButtonContext(button) {
    var wrapper = button.closest('c-product-card, swym-product');
    if (!wrapper) return null;

    var productId = wrapper.dataset.productId;
    var variantId = wrapper.dataset.variantId;
    var productUrl = wrapper.dataset.productUrl || window.location.href;

    if (!productId || !variantId) return null;

    return {
      wrapper: wrapper,
      product: {
        epi: String(variantId),
        empi: String(productId),
        du: productUrl
      }
    };
  }

  function isSameProduct(item, product) {
    return String(item.epi) === String(product.epi) && String(item.empi) === String(product.empi);
  }

  function setButtonState(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function syncWishlistButtons() {
    var items = readWishlist();
    document.querySelectorAll('.js-product-form__wish-button, .js-product-card__wish-button').forEach(function(button) {
      var context = getButtonContext(button);
      if (!context) return;
      setButtonState(button, items.some(function(item) { return isSameProduct(item, context.product); }));
    });
    if (typeof updateWishlistHeaderCounter === 'function') updateWishlistHeaderCounter(items.length);
  }

  function toggleLocalWishlist(button) {
    var context = getButtonContext(button);
    if (!context) return;

    var items = readWishlist().slice();
    var existingIndex = items.findIndex(function(item) { return isSameProduct(item, context.product); });
    var isActive = existingIndex === -1;

    if (isActive) {
      items.push(context.product);
      if (typeof publish === 'function') publish('wishlist-add-product', context.product);
    } else {
      items.splice(existingIndex, 1);
      if (typeof publish === 'function') publish('wishlist-remove-product', context.product);
    }

    writeWishlist(items);
    setButtonState(button, isActive);
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest('.js-product-form__wish-button, .js-product-card__wish-button');
    if (!button || window._swat) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    toggleLocalWishlist(button);
  }, true);

  window.LevingWishlistFallback = {
    read: readWishlist,
    write: writeWishlist,
    sync: syncWishlistButtons,
    toggle: toggleLocalWishlist
  };

  document.addEventListener('DOMContentLoaded', syncWishlistButtons);
  document.addEventListener('swym:collections-loaded', syncWishlistButtons);
  window.addEventListener('pageshow', syncWishlistButtons);
  setTimeout(syncWishlistButtons, 250);
  setTimeout(syncWishlistButtons, 1200);
})();
